export const adminRoles = [
  "jn_admin",
  "jbcc_admin",
  "jn_super_admin",
  "jbcc_super_admin",
  "PARTIAL_SUPER_ADMIN"
];
